import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e187fcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-container" }
const _hoisted_2 = { class: "day-of-week-wrapper" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "월", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "화", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "수", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "목", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "금", -1 /* HOISTED */))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "days-wrapper" }
const _hoisted_11 = ["id", "onClick"]
const _hoisted_12 = { class: "day-title" }
const _hoisted_13 = {
  key: 0,
  class: "seat-num-wrapper"
}
const _hoisted_14 = {
  key: 0,
  class: "seat-num"
}
const _hoisted_15 = {
  key: 1,
  class: "seat-num"
}
const _hoisted_16 = {
  key: 1,
  class: "seat-count"
}
const _hoisted_17 = { class: "seat-count--remain" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "calendar-title" }, _toDisplayString($setup.calendarTitle)),
    _createElementVNode("div", _hoisted_2, [
      ($setup.bookableOnSunday)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "일"))
        : _createCommentVNode("v-if", true),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      ($setup.bookableOnSaturday)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "토"))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.dateInfos, (dateInfo, index) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["day-wrapper", {
          bookable: $setup.isBookableDate(dateInfo),
          selected: $setup.isSelectedDate(dateInfo),
          'bookable-seat': $setup.isBookableSeat(dateInfo),
        }]),
          key: index,
          id: `day-wrapper-${index}`,
          onClick: ($event: any) => ($setup.onClickDay(dateInfo, $event.currentTarget))
        }, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(dateInfo.dayJs.format("D")), 1 /* TEXT */),
          ($props.seatsSelectable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (!!dateInfo.bookableDate?.mySeatNo)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(dateInfo.bookableDate.mySeatNo), 1 /* TEXT */))
                  : (!!dateInfo.bookableDate?.targetSeatNo)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(dateInfo.bookableDate.targetSeatNo), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (!!dateInfo.bookableDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, " 잔여 " + _toDisplayString(dateInfo.bookableDate?.remainingSeatsCount), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_11)
      }), 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}